import React from 'react';

import { fg } from '@atlaskit/platform-feature-flags';

import { useAIAnswerContext } from '../ai-answer-dialog/ai-answer-context';
import { QueryIntent } from '../constants';
import { JiraNlToJqlCard } from '../v2/knowledge-cards/feature-cards/JiraNlToJqlCard/JiraNlToJqlCard';
import { TopicKnowledgeCard } from '../v2/knowledge-cards/feature-cards/TopicKnowledgeCard';

import { AgentKnowledgeCard } from './agent-knowledge-card/agent-knowledge-card';
import { KnowledgeCardLoading } from './knowledge-card-loading';
import { PersonKnowledgeCard } from './person-knowledge-card/person-knowledge-card';
import { TeamKnowledgeCard } from './team-knowledge-card/team-knowledge-card';

export const KnowledgeCard = ({ onFMPReached }: { onFMPReached: () => void }) => {
	const { isAnswered, hasError, smartAnswersRoute, loading, commonAttributes, baseQuery } =
		useAIAnswerContext();
	const { cloudId, brand, searchSessionId, workspaceId, sourceProduct, query } = commonAttributes;

	// Jira NL to JQL Card doesn't populate the context with hasError, isAnswered so we use a separate condition
	if (smartAnswersRoute === QueryIntent.JIRA_NATURAL_LANGUAGE_QUERY) {
		return (
			<JiraNlToJqlCard
				title={query} // query here is overridden with the transformed query in FPS
				query={baseQuery ?? ''} // baseQuery here is the original query from the user
				cloudId={cloudId}
				aiBrand={brand}
				searchSessionId={searchSessionId}
				workspaceId={workspaceId}
				product={sourceProduct ?? ''}
				onFMPReached={onFMPReached}
			/>
		);
	}

	if (loading && fg('kd_people_cards_update')) {
		return <KnowledgeCardLoading queryIntent={smartAnswersRoute} />;
	}

	if (isAnswered && !hasError) {
		switch (smartAnswersRoute) {
			case QueryIntent.TEAM:
				return <TeamKnowledgeCard onFMPReached={onFMPReached} />;
			case QueryIntent.PERSON:
				return <PersonKnowledgeCard onFMPReached={onFMPReached} />;
			case QueryIntent.TOPIC:
				return <TopicKnowledgeCard onFMPReached={onFMPReached} />;
			case QueryIntent.AGENT:
				return <AgentKnowledgeCard onFMPReached={onFMPReached} />;
			case QueryIntent.ORG_CHART:
				return <PersonKnowledgeCard onFMPReached={onFMPReached} />;
			default:
				return null;
		}
	}

	return null;
};
